module.exports = __webpack_public_path__ + "img/loginLogo.72a8eccf.png";